import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { site, whatWeDo } from '../data/site';

const Donate: React.FC = () => (
  <>
    <section className="section">
      <Container>
        <div className="text-center">
          <h1 className="section-title">Donate</h1>
          <hr className="section-rule" />
          <p className="lede mx-auto">
            Art on the Lake is a non-profit. Donations pay for the artist opportunities, classes,
            and community programming that make up everything we do.
          </p>
        </div>
      </Container>
    </section>

    <section className="section bg-water-soft">
      <Container>
        <Row className="justify-content-center g-4">
          <Col lg={7}>
            <div className="bg-white p-4 p-lg-5 shadow-sm h-100">
              <h2 className="section-title h4">How to give</h2>
              <hr className="section-rule section-rule--start" />
              <p>
                To make a donation, or to ask about giving in another way, contact us directly and
                we will get you set up.
              </p>
              <p className="mb-1">
                <strong>Email:</strong>{' '}
                <a href={`mailto:${site.email}?subject=Donation%20to%20Art%20on%20the%20Lake`}>
                  {site.email}
                </a>
              </p>
              <p className="mb-0">
                <strong>Phone:</strong> <a href={site.phoneHref}>{site.phone}</a>
              </p>
            </div>
          </Col>

          <Col lg={5}>
            <div className="bg-white p-4 p-lg-5 shadow-sm h-100">
              <h2 className="section-title h4">Where it goes</h2>
              <hr className="section-rule section-rule--start" />
              <ul className="mb-0 ps-3">
                {whatWeDo.map((item) => (
                  <li key={item} className="mb-2">{item}</li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  </>
);

export default Donate;
